import React from 'react';
import {
  Avatar,
  Box,
  Button,
  Container,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { Link } from 'react-router-dom';

const useStyle = makeStyles((theme) => ({
  link: {
    color: theme.ui.secondary,
    textDecoration: 'none',
    backgroundColor: '#fff',
    marginRight: 3,
    marginLeft: 3,
    '&:hover': {
      backgroundColor: '#fff',
    },
  },
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    height: 160,
  },
  title: {
    marginBottom: 24,
    fontSize: 24,
  },
  mizbanLogo: {
    width: 64,
    height: 64,
  },
}));

export const ActivationError = () => {
  const classes = useStyle();

  return (
    <Container maxWidth='sm' className={classes.container}>
      <Box className={classes.container} mb={5}>
        <Avatar
          className={classes.mizbanLogo}
          src={process.env.PUBLIC_URL + '/icons/mizban.svg'}
        />
        <Typography color='primary' variant='h6'>
          Mizban
        </Typography>
      </Box>
      <Typography className={classes.title}>
        Your email address is not verified
      </Typography>

      <Box className={classes.container} mb={5}>
        <Typography variant='body1'>
          You need to verify email address now in order to sign in to mizban
        </Typography>
      </Box>

      <Box>
        <Button
          variant='contained'
          color='primary'
          component={Link}
          to='/signin'
        >
          Back to Sign in
        </Button>
      </Box>
    </Container>
  );
};
